import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CreateForm from 'components/event/CreateForm';
import StyledModalHeader from 'components/modal/StyledModalHeader';
import StyledModalBody from 'components/modal/StyledModalBody';

import { cancelDuplicatingEvent, duplicateEvent } from 'actions/Event';

import {
  getTeamMembers,
  getTeam,
  createTeamLabel,
} from 'actions/Team';

import { Modal } from 'reactstrap';

const DuplicateEventModal = ({
  modalOpen,
  cancelDuplicatingEvent,
  duplicateEvent,
  createTeamLabel,
  event,
  team,
  getTeamMembers,
  getTeam,
  teamMembers,
  tags,
}) => {
  useEffect(() => {
    if (!event) return;

    getTeam(event.team._id);

    getTeamMembers(event.team._id);
  }, [event, getTeam, getTeamMembers]);

  /**
   * Shouldn't show the form if there is no event object (has the teamId)
   * Shouldn't show the for if there are no team members (there should always be 1+ team members)
   */
  const readyToShowForm = team && event && teamMembers && teamMembers.length;
  const teamId = readyToShowForm ? event.team._id || event.team : null;

  const title = readyToShowForm ? `Duplicate ${event.title}` : '';

  const labels = team ? team.labels : [];

  return (
    <Modal isOpen={modalOpen} toggle={cancelDuplicatingEvent}>
      <StyledModalHeader toggle={cancelDuplicatingEvent}>
        {title}
      </StyledModalHeader>
      <StyledModalBody>
        {readyToShowForm && (
          <CreateForm
            owners={teamMembers}
            event={event}
            team={team}
            tags={tags}
            labels={labels}
            onSubmit={(formData, photoFile, labels, templates) => {
              duplicateEvent(
                teamId,
                event._id,
                formData,
                photoFile,
                //passing empty labels for now, need to populate labels separately in state because sometimes team.labels is just ids
                labels,
                templates,
              );
            }}
            onLabelCreated={createTeamLabel.bind(null, teamId)}
            onCancel={cancelDuplicatingEvent}
          />
        )}
      </StyledModalBody>
    </Modal>
  );
};

export default connect(
  (state) => {
    const {
      duplicatingEvent,
      selectedTeamMembers,
      team,
      tags,
      user,
    } = state;

    return {
      team,
      tags,
      user,
      modalOpen: duplicatingEvent ? true : false,
      event: duplicatingEvent,
      teamMembers: selectedTeamMembers,
    };
  },
  {
    duplicateEvent,
    createTeamLabel,
    cancelDuplicatingEvent,
    getTeamMembers,
    getTeam,
  },
)(DuplicateEventModal);
